<script lang="ts">
  import type { ServerResult } from '../anim/server';
  import { t } from '../i18n/index.svelte';

  let { result }: { result: ServerResult } = $props();
  let video = $state<HTMLVideoElement | null>(null);
  let fit = $state(true);

  function step(d: number) {
    if (!video) return;
    video.pause();
    video.currentTime = Math.max(0, Math.min(video.duration || 0, video.currentTime + d / result.fps));
  }
</script>

<div class="media">
  <div class="stage" class:fit>
    {#if result.format === 'gif'}
      <img src={result.url} alt={t('server.result')} data-testid="server-media" />
    {:else if result.format === 'zip'}
      <p class="muted">{t('server.zipReady')}</p>
    {:else}
      <!-- svelte-ignore a11y_media_has_caption -->
      <video bind:this={video} src={result.url} autoplay loop muted playsinline controls data-testid="server-media"
      ></video>
    {/if}
  </div>
  <div class="controls">
    {#if video}
      <button onclick={() => step(-1)} aria-label={t('player.prev')}>⏮</button>
      <button onclick={() => (video!.paused ? video!.play() : video!.pause())} aria-label={t('player.play')}>⏯</button>
      <button onclick={() => step(1)} aria-label={t('player.next')}>⏭</button>
    {/if}
    <span class="mono muted">
      {result.width}×{result.height} · {result.frames} · {result.fps} fps · {(result.blob.size / 1e6).toFixed(1)} MB
    </span>
    <span class="grow"></span>
    <div class="seg">
      <button class:on={fit} onclick={() => (fit = true)}>{t('preview.fit')}</button>
      <button class:on={!fit} onclick={() => (fit = false)}>1:1</button>
    </div>
  </div>
</div>

<style>
  .media {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }
  .stage {
    flex: 1;
    min-height: 0;
    overflow: auto;
    display: grid;
    place-items: center;
    padding: 16px;
    background: repeating-conic-gradient(#14161b 0% 25%, #111317 0% 50%) 50% / 24px 24px;
  }
  .stage.fit img,
  .stage.fit video {
    max-width: 100%;
    max-height: 100%;
  }
  .controls {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px 12px;
    border-top: 1px solid var(--line);
    background: var(--panel);
  }
  .grow {
    flex: 1;
  }
</style>
